<!-- <section class="section"> -->
<!-- <div class="flex-row">
    <div class="flex-col-sm-6">
      <div class="section__title">
        <h3>Recent Activities</h3>
        <p>Total number of Activity</p>
      </div>
    </div>
    <div class="flex-col-sm-6">
      <div class="section__actions">
        <app-predective-search></app-predective-search>
      </div>
    </div>
  </div> -->
<f-table [columns]="columns" [rows]="rows | paginate: pagingConfig">
  <!-- <ng-template tTemplate="header" let-columns="columns">
      <tr>
        <th *ngFor="let column of columns" [columnSort]="column" (sort)="onSort($event)">
          <ng-container *ngIf="column.display !== false">
            {{ column.name }}
            <ng-container *ngIf="column.sort !== false">
              <span><i class="fa fa-sort" *ngIf="!column.order"></i></span>
              <span><i class="fa-duotone fa-sort-up" *ngIf="column.order > 0"></i></span>
              <span><i class="fa-duotone fa-sort-down" *ngIf="column.order < 0"></i></span>
            </ng-container>
          </ng-container>
        </th>
      </tr>
    </ng-template> -->
  <ng-template tTemplate="nodata">
    <tr>
      <td colspan="100%" align="center">
        <i class="no-data__icon fa-light fa-chart-line"></i>
        No {{ tag !== '' ? tag.toLowerCase() : 'record' }} at the moment
      </td>
    </tr>
  </ng-template>
  <ng-template tTemplate="body" let-row="row" let-rowIndex="rowIndex">
    <tr>
      <ng-container *ngIf="row.activityType === 'call'">
        <td>
          <i [class]="row.state"></i>
        </td>
        <td>
          <div class="user-module user-module--detailed">
            <div class="user-module__avatar">
              <span>{{ getNameInitials(row.user_details) }}</span>
            </div>
            <div data-tooltip="User" data-tooltip-conf="bottom" class="user-module__details">
              <p [class]="row.direction.directionClass">{{ row.direction.name }}</p>
              <span>{{ row.user_details }}</span>
            </div>
          </div>
        </td>
        <!-- <td data-tooltip="BTN" data-tooltip-conf="bottom">
            <i class="fa-light fa-barcode"></i>
            {{ row.btn }}
          </td> -->
        <td>
          <span data-tooltip="Skill" data-tooltip-conf="bottom">{{ row.skills }}</span>
        </td>
        <td colspan="2">
          <div [attr.data-tooltip]="'Disposition: \n' + row.disposition" data-tooltip-conf="bottom"
            class="chips chips--without-icon">
            <span class="chips__value chips__value--danger">{{ row.disposition }}</span>
          </div>
        </td>
        <td>
          <span data-tooltip="Call Start Time" data-tooltip-conf="bottom">{{ row.action }}</span>

        </td>
        <td *ngIf="row.skills !== 'K01' && row.skills !== 'K02' && row.skills !== 'TS2'" (clickOutside)="row.show = false">
          <span data-tooltip="Call2" data-tooltip-conf="bottom">
            <i class="fa-solid fa-phone call-status-icon"
              [ngClass]="{'disabled' : callIndex == rowIndex && !callEnabled }" (click)="toggleCallOption(row)"></i>
            <div class="dropdown-content" [ngClass]="{'show': row.show }">
              <a href="javascript:void(0);" (click)="dialCall(row['btn'], rowIndex, row['tfn'], row['campaign'], row['ucid'])"><i
                  class="fa-solid fa-phone fa-fw"></i> Primary Number</a>
              <a href="javascript:void(0);"
                (click)="dialCall(row['callbackNumber'], rowIndex, row['tfn'], row['campaign'], row['ucid'])"><i
                  class="fa-solid fa-phone fa-fw"></i> Callback Number</a>
            </div>

          </span>
          <!-- <i class="fa-regular fa-ellipsis-vertical"></i> -->
        </td>
      </ng-container>
      <ng-container *ngIf="row.activityType === 'sale'">
        <td>
          <i [class]="row.state"></i>
        </td>
        <td data-tooltip="OCN" data-tooltip-conf="bottom">
          {{ row.confirmation_number }}
        </td>
        <td data-tooltip="Skill" data-tooltip-conf="bottom">
          <span>{{ row.skills }}</span>
        </td>
        <td>
          <div class="chips chips--without-icon" data-tooltip="RGUs" data-tooltip-conf="bottom">
            <span class="chips__value chips__value--success">{{ row.rgus }}</span>
          </div>
        </td>
        <td>
          <div class="chips chips--without-icon" data-tooltip="Cable Company" data-tooltip-conf="bottom">
            <span class="chips__value chips__value--success-secondary">{{ row.cable_company }}</span>
          </div>
        </td>
        <td data-tooltip="TFN" data-tooltip-conf="bottom">
          <i class="fa-light fa-tag"></i>
          {{ row.tfns }}
        </td>
        <td [attr.data-tooltip]="'Call SID:\n' + row.call_sid" data-tooltip-conf="bottom multiline">
          <span class="call_sid">
            {{ row.call_sid }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="row.activityType === 'chat'">
        <td><i class="skin-primary sn-icons" [ngClass]="row.icon"></i></td>
        <td>
          <div class="user-module user-module--detailed">
            <div class="user-module__avatar">
              <span>{{ getNameInitials(row.customerInfo.Name || row.nickName) }}</span>
            </div>
            <div class="user-module__details">
              <p class="skin-primary">{{ ParticipantChannelType[row.channelType] }}</p>
              <span data-tooltip="User" data-tooltip-conf="bottom">{{ row.customerInfo.Name || row.nickName }}</span>
            </div>
          </div>
        </td>
        <td>
          <span data-tooltip="Skill" data-tooltip-conf="bottom">{{ row.campaignName | campaignCode }}</span>
        </td>
        <td>
          <div class="chips chips--without-icon" data-tooltip="Disposition" data-tooltip-conf="bottom">
            <span class="chips__value chips__value--success">
              {{ row.disposition || 'N/A' }}
            </span>
          </div>
        </td>
        <td>
          <span data-tooltip="TFN" data-tooltip-conf="bottom">
            <i class="fa-regular fa-mobile-notch"></i>{{ row.site.tfn || 'N/A' }}
          </span>
        </td>
        <td>
          <span data-tooltip="Site URL" data-tooltip-conf="bottom">
            <i class="fa-light fa-barcode"></i>{{ row.site.url || 'N/A' }}
          </span>
        </td>
        <td>
          <div class="chat-box-wrapper">
            <div class="chat-box chat-box--table">
              <p class="chat-box__message" data-tooltip="Last Message" data-tooltip-conf="bottom">
                {{ row.lastMessage && row.lastMessage.body ? row.lastMessage.body : 'N/A' }}
              </p>
            </div>
          </div>
        </td>
      </ng-container>
    </tr>
  </ng-template>
</f-table>
<!-- <div class="paging mt-3" >
    <pagination-controls [maxSize]="pagingConfig.itemsPerPage" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [id]="pagingConfig.id"></pagination-controls>
  </div> -->
<!-- </section> -->